const cn = {
    menu:{
		list:[
			{href:'/index',name:'首页'},
			{href:'/product',name:'产品服务'},
			{href:'/news',name:'新闻动态'},
			{href:'/video',name:'工程案例'},
      {href:'/about',name:'关于我们'},
			{href:'/contact',name:'联系我们'},
		],
		bottom:[
			{
				title: '企业介绍',
				url: [
					{href:'/contact',name:'联系我们'},
					{href:'/about',name:'关于我们'},
				]
			},
			{
				title: '服务范围',
				url: [
					{href:'/product',name:'产品服务'},
					{href:'/news',name:'新闻动态'},
				]
			},
			{
				title: '法律条款',
				url: [
					{href:'/',name:'条款'},
				]
			},
		]
	},
	about:{
		explain:[
			{a:'2008',b:'年',c:'公司创立于2008年'},
			{a:'200',b:'万',c:'已安全运营超过200万小时'},
			{a:'1000',b:'条',c:'已销售超1000条'},
			{a:'80',b:'个',c:'业务覆盖全国80多座城市'},
		],
		details:[
			{text:'佛山市鼎吉包装技术有限公司成立于2008年,是一家集研发、设计、制造、安装为一体的高新技术型企业。专业致力于研发生产陶瓷墙地砖拣选包装自动化设备。公司遵循“以市场为导向、以研发为动力、以质量为核心竞争力”的发展宗旨服务建陶企业，为建陶产业的生产自动化和可持续发展做贡献。'},
			{text:'鼎吉公司拥有强大的研发创新能力,研发的瓷砖分选、瓷砖翻面、瓷砖层叠、瓷砖衬纸、砖垛上载、砖垛理直、砖垛包角、纸箱成型、砖包捆扎、砖包旋转、砖包翻面、砖包堆垛等自动化技术获得了多项国家发明专利，被广泛应用于瓷砖的自动化拣选包装生产环节,其先进的功能设计及稳定可靠的设备性能赢得了国内外用户的一致好评，产品远销到世界各地，外销市场已占公司总销售额的一半，产品在业内有明显的技术优势,也获得了陶机装备行业的普遍认可及效仿。'},
			{text:'目前公司与意大利喷墨机进行广泛的合作，强强联合，优势互补，资源共享，事实证明，选择鼎吉就是选择共同进步的伙伴！'},
		]
	},
	corp:{
		name: '鼎吉包装技术有限公司',
		address: '地址：佛山市南海狮山工业园C区兴业路14号',
		Telephone: '电话：0757-86689109',
		Email: '邮箱：dinovormarketing@163.com',
	},
	contact:{
		text:'佛山市鼎吉包装技术有限公司,是一家集研发、设计、制造、安装为一体的高新技术型企业.专业致力于研发生产陶瓷墙地砖拣选包装自动化设备。公司遵循“质量就是力量”的发展宗旨服务建陶企业，为建陶产业的生产自动化和可持续发展做贡献。',
		list01:{
		  title:'客服服务',
		  text1:'公司地址：佛山市南海区狮山科技工业园C区兴业西路14号',
		  text2:'电话/传真：15118799738  黄小姐',
		  text3:'公司邮箱：dinovormarketing@163.com',
		  text4:'公司业务QQ：2352221613',
		  text5:'市场部经理：何经理13927798980'
		},
		list02:{
		  title:'商务合作',
		  text1:'华南地区：',
		  text2:'华东地区：',
		  text3:'华中地区：',
		  text4:'海外地区：'
		},
		online:{
			text:'可提交对我们的意见或建议',
			name: '姓名',
			phone: '电话',
			Email: '邮箱',
			message: '留言',
			submit: '提交',
		}
	},
	news:{
		nav:[
			{id: 1,name: '企业新闻'},
			{id: 2,name: '行业新闻'}
		]
	},
	honor:{
		nav:[
			{id: 1,name: '产品专利证书'},
			{id: 2,name: '公司获奖荣誉'}
		]
	},
	parameter : '参数',
}
export default cn;


// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js